import { getUserCookieValues } from 'utils/userAuth'
import { userGroupBooleans } from 'utils/userTypes'
import { IUserTypes } from 'constants/userTypes'

export interface IGenerateDefaultRoutesOptions {
  authToken?: string
  groups?: string
  userType?: string
  isAdmin?: boolean
  isCarrier?: boolean
  isShipper?: boolean
  isCeRep?: boolean
  isCxRep?: boolean
  isCmRep?: boolean
  isNorthEast?: boolean
  isNorthEastCmRep?: boolean
  fullName?: string
}

export const getDefaultRouteUserOptions = (): IGenerateDefaultRoutesOptions => {
  const { authToken, firstName = '', groups, lastName = '', userType } = getUserCookieValues()
  const { isAdmin = false, isCarrier = false, isShipper = false } = userGroupBooleans(
    userType as keyof IUserTypes
  )
  const isCeRep = !!(groups && groups.includes('Carrier Experience'))
  const isCxRep = !!(groups && groups.includes('Customer Experience'))
  const isCmRep = !!(groups && (groups.includes('CM') || groups.includes('Cm')))
  const isNorthEast = !!(groups && groups.includes('NorthEast'))
  const isNorthEastCmRep = !!(isCmRep && isNorthEast)
  const fullName = [firstName, lastName].join(' ')
  return {
    authToken,
    groups,
    userType,
    isAdmin,
    isCarrier,
    isShipper,
    isCeRep,
    isCxRep,
    isCmRep,
    isNorthEast,
    isNorthEastCmRep,
    fullName,
  }
}
